import * as api from '../api/scriptConfiguration.api';
import { ScriptConfiguration, ConvertedScriptConfiguration } from '../types/scriptConfiguration';

export type ScriptConfigurationParams = {
  appId: string;
  siteCode: string;
  scriptName: string;
  errorCode?: string | null;
};

export const getApps = async (params: Omit<ScriptConfigurationParams, 'appId'>) => {
  const { apps = [] } = await api.getApps(params);
  return apps;
};

export const getErrorsCode = async (params: ScriptConfigurationParams) => {
  const { errorCodes = [] } = await api.getErrorsCode(params);
  return errorCodes;
};

export const getScriptConfiguration = async (params: ScriptConfigurationParams) => {
  const [{ script_Configuration }, { errorCodes }] = await Promise.all([
    api.getScriptConfiguration(params),
    api.getErrorsCode(params),
  ]);

  const convertedData: ConvertedScriptConfiguration = {
    ...script_Configuration,
    emailSubscription: script_Configuration.emailSubscription?.split(',').filter(Boolean) ?? [],
    excludeErrorCodes: script_Configuration.excludeErrorCodes?.split(',').filter(Boolean) ?? [],
    generalErrorCodes: errorCodes.map(String),
  };

  return convertedData;
};

export const updateScriptConfiguration = (scriptConfiguration: ConvertedScriptConfiguration) => {
  const preparedScriptConfiguration: ScriptConfiguration.Request = {
    scriptErrorConfigId: scriptConfiguration.scriptErrorConfigId,
    appId: scriptConfiguration.appId,
    siteCode: scriptConfiguration.siteCode,
    scriptName: scriptConfiguration.scriptName,
    scriptHealth: scriptConfiguration.scriptHealth,
    priorityOverride: scriptConfiguration.priorityOverride,
    errorThresholdOverride: scriptConfiguration.errorThresholdOverride,
    emailSubscription: scriptConfiguration.emailSubscription.join(','),
    excludeErrorCodes: scriptConfiguration.excludeErrorCodes.join(','),
  };

  return api.postScriptConfiguration(preparedScriptConfiguration);
};
